// extracted by mini-css-extract-plugin
export default {"Date":"DateInput_Date","label":"DateInput_label","fields":"DateInput_fields","year":"DateInput_year","month":"DateInput_month","day":"DateInput_day","error":"DateInput_error"};